import React, { useEffect, useState } from "react";
import {
  Card,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
  Label,
  Input
} from "reactstrap";
import whatsapp from "../../assets/images/whatsapp.png";
import telegram from "../../assets/images/telegram.png";
import facebook from "../../assets/images/facebook.png";
import telefonia from "../../assets/images/telefonia.png";
import classnames from "classnames";
import "./css/SideComponent.css";
import {
  getConversationsGestion,
  getConversationsGestionFilter,
  getGestionFinalizadas,
  getLeadsFilterCount,
  getNewConversations,
  getNewConversationsFilter,
  getWhatsappPriority,
  patchWhatsappPriority,
  postAssignConversation
} from "../../helpers/backend";
import ModalManagementDetails from "./components/ModalManagementDetails";
import { useHistory, useLocation } from "react-router-dom";
import ManagementManual from "./components/ManagementManual";
import Pagination from "../../components/Common/Pagination_ansync";
import PhoneVerificationModal from "./components/PhoneVerificationModal";

export const SideComponent = ({
  onPhoneNumberSelect,
  onContactId,
  onCampaignId,
  onLead,
  onChatType,
  managementUpdate,
  updateLeadOpen,
  contactsRefresh,
  setContactsRefresh
}) => {
  const URL = process.env.REACT_APP_API_URL.split("/");
  const user = JSON.parse(localStorage.getItem("user"));
  const groups = String(user.groups);
  const location = useLocation();
  const history = useHistory();
  const [managementFinished, setManagementFinished] = useState({});
  const [modalFinishedDetails, setModalFinishedDetails] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [manualOpen, setManualOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("today");

  const [orderBy, setOrderBy] = useState("");
  const [sortOrder, setSortOrder] = useState("desc"); // Nuevo estado para el orden
  const [currentFilter, setCurrentFilter] = useState("");
  const [activeTab, setActiveTab] = useState("1");
  const [activeTab2, setActiveTab2] = useState("1");
  const [finished, setFinished] = useState({});
  const [management, setManagement] = useState({
    count: 0,
    next: null,
    previous: null,
    results: []
  });
  const [inLine, setInLine] = useState({
    count: 0,
    next: null,
    previous: null,
    results: []
  });
  const [leadsCount, setLeadsCount] = useState(null);
  const [priority, setPriority] = useState({});

  // Función para alternar el orden
  const toggleSortOrder = () => {
    setSortOrder((prevOrder) => {
      const newOrder = prevOrder === "desc" ? "asc" : "desc";
      setOrderBy(newOrder); // Actualiza el parámetro de orden también
      console.log(newOrder);
      return newOrder;
    });
  };

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setOrderBy("");
      setCurrentFilter("");
      setSortOrder("desc"); // Resetear al orden por defecto
    }
  };

  const toggle2 = (tab) => {
    if (activeTab2 !== tab) {
      setActiveTab2(tab);
      setOrderBy("");
      setCurrentFilter("");
      setSortOrder("desc"); // Resetear al orden por defecto
    }
  };

  const getFinishedData = async () => {
    const response = await getGestionFinalizadas(selectedOption);
    setFinished(response.data);
  };

  const buildFilterUrl = (customOrderBy = orderBy) => {
    const params = new URLSearchParams();
    if (customOrderBy) params.set("order_by", customOrderBy);
    // otros filtros aquí
    return params.toString();
  };

  const getManagementData = async (filterUrl = "") => {
    let url = filterUrl || buildFilterUrl(orderBy);
    if (!url) url = buildFilterUrl(orderBy);

    const response = url
      ? await getConversationsGestionFilter(
          url.startsWith("?") ? url : `?${url}`
        )
      : await getConversationsGestion();
    setManagement(response.data);
    setCurrentFilter(url);
  };

  const getInLineData = async (filterUrl = "") => {
    let url = filterUrl || buildFilterUrl(orderBy);
    if (!url) url = buildFilterUrl(orderBy);

    const response = url
      ? await getNewConversationsFilter(url.startsWith("?") ? url : `?${url}`)
      : await getNewConversations();
    setInLine(response.data);
    setCurrentFilter(url);
  };

  const getLeadsData = async () => {
    const response = await getLeadsFilterCount(
      `?tipo_lead=event&fecha_inicio=&fecha_fin=&estado=PENDIENTE`
    );
    setLeadsCount(response.data.count);
  };

  const getPriorityData = async () => {
    const response = await getWhatsappPriority();
    setPriority(response.data);
  };

  const handleInLine = async (id) => {
    await postAssignConversation(id);
    getManagementData();
    getInLineData();
    setActiveTab2("1");
  };

  const isSelected = (id) => selectedItem === id;

  const replaceLocation = () => {
    history.replace({
      pathname: location.pathname,
      state: {}
    });
  };

  const handleTimeChange = async (newValue, id, index) => {
    const updatedResults = [...priority.results];
    updatedResults[index].time = newValue;
    setPriority({ ...priority, results: updatedResults });
    await patchWhatsappPriority(id, { time: newValue });
  };

  const handleManagementPageChange = async (url) => {
    let fullUrl = url;
    if (currentFilter) {
      fullUrl += fullUrl.includes("?") ? "&" : "?";
      fullUrl += currentFilter;
    }
    const response = await getConversationsGestionFilter(fullUrl);
    setManagement({
      count: response.data.count,
      next: response.data.next,
      previous: response.data.previous,
      results: response.data.results
    });
  };

  const handleInLinePageChange = async (url) => {
    let fullUrl = url;
    if (currentFilter) {
      fullUrl += fullUrl.includes("?") ? "&" : "?";
      fullUrl += currentFilter;
    }
    const response = await getNewConversationsFilter(fullUrl);
    setInLine({
      count: response.data.count,
      next: response.data.next,
      previous: response.data.previous,
      results: response.data.results
    });
  };

  const handleLeadClick = () => {
    updateLeadOpen(true);
  };

  useEffect(() => {
    getManagementData();
    getInLineData();
    getPriorityData();
    getLeadsData();
    setContactsRefresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [managementUpdate, contactsRefresh]);

  useEffect(() => {
    getFinishedData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOption]);

  // Efecto para aplicar el orden cuando cambia
  useEffect(() => {
    if (activeTab === "1") {
      if (activeTab2 === "1") {
        getManagementData();
      } else if (activeTab2 === "2") {
        getInLineData();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderBy]);

  useEffect(() => {
    const chatSocketInLine = new WebSocket(
      `wss://${URL[2]}/ws/new_conversation/`
    );
    chatSocketInLine.onmessage = async () => await getInLineData();
    return () => chatSocketInLine.close();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const chatSocketManagement = new WebSocket(
      `wss://${URL[2]}/ws/en_gestion_conversation/`
    );
    chatSocketManagement.onmessage = async () => await getManagementData();
    return () => chatSocketManagement.close();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Row>
      <Card className="chat-panel-container">
        <div className="management-panel">
          <button
            className="floating-action-btn"
            onClick={() => setModalOpen(true)}
          >
            <i className="fas fa-plus"></i>
          </button>

          {modalOpen && (
            <PhoneVerificationModal
              isOpen={modalOpen}
              onClose={() => setModalOpen(false)}
              refresh={getManagementData}
            />
          )}

          <Nav className="main-navigation-tabs">
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "1" })}
                onClick={() => toggle("1")}
              >
                <i className="fas fa-comment-alt"></i>
                <span>Abierto</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "2" })}
                onClick={() => toggle("2")}
              >
                <i className="fas fa-check"></i>
                <span>Finalizado</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "3" })}
                onClick={() => setManualOpen(true)}
              >
                <i className="fas fa-phone-alt"></i>
                <span>Gestión</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "4" })}
                onClick={handleLeadClick}
              >
                <i className="fas fa-users"></i>
                <span>
                  Leads
                  {leadsCount > 0 && (
                    <span className="notification-badge">{leadsCount}</span>
                  )}
                </span>
              </NavLink>
            </NavItem>
            {(groups.includes("SuperAdmin") ||
              groups.includes("Administrador") ||
              groups.includes("Supervisor")) && (
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "5" })}
                  onClick={() => toggle("5")}
                >
                  <i className="fas fa-tools"></i>
                  <span>Config</span>
                </NavLink>
              </NavItem>
            )}
          </Nav>

          {manualOpen && (
            <ManagementManual
              isOpen={manualOpen}
              onClose={() => setManualOpen(false)}
            />
          )}

          {activeTab === "1" && (
            <>
              <Nav className="sub-navigation-tabs">
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab2 === "1" })}
                    onClick={() => toggle2("1")}
                  >
                    <span>
                      Mis Gestiones
                      <span className="count-badge">{management.count}</span>
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab2 === "2" })}
                    onClick={() => toggle2("2")}
                  >
                    <span>
                      En Espera
                      <span className="count-badge">{inLine.count}</span>
                    </span>
                  </NavLink>
                </NavItem>
                {/* Botón de ordenamiento */}
                <NavItem className="ml-auto">
                  <NavLink
                    onClick={toggleSortOrder}
                    style={{ cursor: "pointer" }}
                  >
                    <i
                      className={`fas fa-sort-amount-${
                        sortOrder === "asc" ? "up" : "down"
                      }`}
                    />
                  </NavLink>
                </NavItem>
              </Nav>
              <div className="conversation-list">
                {activeTab2 === "1" &&
                  management.results?.map((item, index) => (
                    <ConversationItem
                      key={`management-${index}`}
                      item={item}
                      isSelected={isSelected(item.id)}
                      onClick={() => {
                        onPhoneNumberSelect(item.id);
                        onContactId(item.contacto?.contact_id);
                        onCampaignId(item.campaign || []);
                        onLead(item.leads || []);
                        onChatType(item.type);
                        setSelectedItem(item.id);
                        updateLeadOpen(false);
                        replaceLocation();
                      }}
                    />
                  ))}

                {activeTab2 === "2" &&
                  inLine.results?.map((item, index) => (
                    <ConversationItem
                      key={`inline-${index}`}
                      item={item}
                      onClick={() => {
                        handleInLine(item.id);
                        onPhoneNumberSelect(item.id);
                        onCampaignId(item.campaign || []);
                        onContactId(item.contacto?.contact_id);
                        setSelectedItem(item.id);
                        onChatType(item.type);
                      }}
                    />
                  ))}
              </div>

              <div className="pagination-container">
                {activeTab2 === "1" && (
                  <Pagination
                    count={management.count}
                    next={management.next}
                    previous={management.previous}
                    limit={30}
                    baseUrl="/whatsapp/conversation/get_conversation_gestion"
                    filterFunction={handleManagementPageChange}
                  />
                )}
                {activeTab2 === "2" && (
                  <Pagination
                    count={inLine.count}
                    next={inLine.next}
                    previous={inLine.previous}
                    limit={30}
                    baseUrl="/whatsapp/conversation/get_conversation_new"
                    filterFunction={handleInLinePageChange}
                  />
                )}
              </div>
            </>
          )}

          {activeTab === "2" && (
            <div className="finished-conversations">
              <div className="finished-header">
                <h6>Mis Gestiones Finalizadas</h6>
                <select
                  className="time-filter"
                  onChange={(e) => setSelectedOption(e.target.value)}
                  defaultValue="today"
                >
                  <option value="all">Todas</option>
                  <option value="today">Hoy</option>
                  <option value="yesterday">Ayer</option>
                  <option value="week">Semana</option>
                  <option value="month">Mes</option>
                </select>
              </div>

              <div className="finished-list">
                {finished?.map((item, index) => (
                  <ConversationItem
                    key={`finished-${index}`}
                    item={item}
                    isFinished
                    onClick={() => {
                      setManagementFinished(item);
                      setModalFinishedDetails(true);
                    }}
                  />
                ))}
              </div>

              {modalFinishedDetails && (
                <ModalManagementDetails
                  isOpen={modalFinishedDetails}
                  onCloseClick={() => setModalFinishedDetails(false)}
                  GestionDetallada={managementFinished}
                />
              )}
            </div>
          )}

          {activeTab === "5" && (
            <div className="configuration-panel">
              <div className="accordion">
                <div className="accordion-item">
                  <h6 className="accordion-header">
                    <button className="accordion-button">Prioridades</button>
                  </h6>
                  <div className="accordion-body">
                    {priority.results?.map(
                      (item, idx) =>
                        item.name !== "GESTION" && (
                          <Row key={idx} className="priority-item">
                            <Col xs={4} className="priority-label">
                              <Label>{item.name}</Label>
                            </Col>
                            <Col xs={8}>
                              <Input
                                type="select"
                                value={item.time}
                                onChange={(e) =>
                                  handleTimeChange(e.target.value, item.id, idx)
                                }
                              >
                                <option value="">------------</option>
                                <option value="2">2 Minutos</option>
                                <option value="5">5 Minutos</option>
                                <option value="8">8 Minutos</option>
                                <option value="10">10 Minutos</option>
                              </Input>
                            </Col>
                          </Row>
                        )
                    )}
                  </div>
                </div>

                <div className="accordion-item">
                  <h6 className="accordion-header">
                    <button className="accordion-button">
                      Cierre de Gestión
                    </button>
                  </h6>
                  <div className="accordion-body">
                    {priority.results?.map(
                      (item, idx) =>
                        item.name === "GESTION" && (
                          <Row key={idx} className="priority-item">
                            <Col xs={6} className="priority-label">
                              <Label>Tiempo para cerrar</Label>
                            </Col>
                            <Col xs={6}>
                              <Input
                                type="select"
                                value={item.time}
                                onChange={(e) =>
                                  handleTimeChange(e.target.value, item.id, idx)
                                }
                              >
                                <option value="">------------</option>
                                <option value="5">5 Horas</option>
                                <option value="10">10 Horas</option>
                                <option value="12">12 Horas</option>
                                <option value="20">20 Horas</option>
                                <option value="24">24 Horas</option>
                              </Input>
                            </Col>
                          </Row>
                        )
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </Card>
    </Row>
  );
};

const ConversationItem = ({ item, isSelected, isFinished, onClick }) => {
  const getPlatformIcon = () => {
    switch (item.type) {
      case "WhatsApp":
        return whatsapp;
      case "Telegram":
        return telegram;
      case "Facebook":
        return facebook;
      case "Telefonia":
      case "Telefonía - Manual":
        return telefonia;
      default:
        return null;
    }
  };

  const getPriorityColor = () => {
    if (isFinished) return "#fd7e14";
    return item.prioridad === "MEDIO"
      ? "#ffc107"
      : item.prioridad === "ALTO"
      ? "#dc3545"
      : "#28a745";
  };
  // Funciones para generar colores (puedes ponerlas en un archivo de utilidades)
  const stringToColor = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const color = `hsl(${hash % 360}, 70%, 80%)`;
    return color;
  };

  const getContrastColor = (bgColor) => {
    // Convierte color HSL a RGB primero si es necesario
    // Esta es una versión simplificada para colores claros/oscuros
    return bgColor.includes("70%, 80%") ? "#333" : "#fff";
  };
  return (
    <div
      className={`conversation-item ${isSelected ? "selected" : ""}`}
      style={{ borderLeft: `3px solid ${getPriorityColor()}` }}
      onClick={onClick}
    >
      <div className="platform-icon">
        <img src={getPlatformIcon()} alt={item.type} />
        {!isFinished && item.message_received > 0 && (
          <span className="unread-messages">{item.message_received}</span>
        )}
      </div>

      <div className="conversation-content">
        <div className="conversation-header">
          <span className="contact-name-chat">
            {item.contacto && isFinished
              ? item.contacto
              : item.contacto.contact_name || item.id}
          </span>

          {/* Mostrar todas las campañas como badges */}
          {item.campaign?.length > 0 && (
            <div className="campaign-badges-container">
              {item.campaign.map((camp, index) => (
                <span
                  key={index}
                  className="campaign-badge"
                  style={{
                    backgroundColor: stringToColor(camp.name), // Función para generar color único
                    color: getContrastColor(stringToColor(camp.name)) // Color de texto contrastante
                  }}
                >
                  {camp.name}
                </span>
              ))}
            </div>
          )}

          <span className="conversation-time">
            {isFinished
              ? `Finalizado: ${item.fecha_finalizacion}`
              : item.last_message_at}
          </span>
        </div>

        {!isFinished && (
          <div className="agent-info">
            Agente: {item.agent?.[0]?.[0] || "No asignado"}
          </div>
        )}

        <div className="last-message">
          {item.ultimo_message?.[0] === "text" ? (
            item.ultimo_message[2] ? (
              `Tu: ${item.ultimo_message[1]}`
            ) : (
              item.ultimo_message[1]
            )
          ) : item.ultimo_message?.[0] === "image" ||
            item.ultimo_message?.[0] === "audio" ||
            item.ultimo_message?.[0] === "document" ? (
            item.ultimo_message[2] ? (
              "Tu: Archivo"
            ) : (
              "Archivo"
            )
          ) : isFinished ? (
            <span className="finished-label">Conversación finalizada</span>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default SideComponent;
